export default class AlertResultCount {
  constructor(observer) {
    this.observer = observer;
  }

  markLineConfig() {
    let config = { lineStyle: { color: "red" } };
    if (this.operator == "eq") {
      config.lineStyle.color = "green";
    }

    let v = this.value;
    if (this.operator === "gt") {
      v = v + 1;
    } else if (this.operator === "lt") {
      v = v - 1;
    }

    return {
      ...config,
      data: [
        {
          yAxis: v,
          name: "Threshold",
        },
      ],
    };
  }

  get operator() {
    return this.observer?.trigger_config?.config?.operator;
  }

  get value() {
    return this.observer?.trigger_config?.config?.value;
  }

  get startVal() {
    switch (this.operator) {
      case "gt":
        return this.value + 1;
      case "gte":
        return this.value;
      case "lt":
        return 0;
      case "lte":
        return 0;
      default:
        return null;
    }
  }

  get endVal() {
    switch (this.operator) {
      case "gte":
        return null;
      case "gt":
        return null;
      case "lt":
        return this.value - 1;
      case "lte":
        return this.value;
      default:
        return null;
    }
  }

  markAreaConfig({ startAt, endAt }) {
    if (["gt", "lt", "gte", "lte"].includes(this.operator)) {
      return {
        data: [this.markAreaData({ startAt, endAt })],
      };
    } else {
      return {
        data: [],
      };
    }
  }

  markAreaData({ startAt, endAt }) {
    return [
      { coord: [startAt, this.startVal] },
      { coord: [endAt, this.endVal] },
    ];
  }
}
